"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderPreview = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../constants");
var _hooks = require("../../hooks");
var _logger = require("../../logger");
var _models = require("../../models");
var _OrderProductItem = require("./OrderProductItem");
var _styles = require("./styles");
var _useOrderPreview = require("./useOrderPreview");
var _jsxRuntime = require("react/jsx-runtime");
const OrderPreview = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { isMoreDesktop, isMoreMobile, itemCount, orderPreviewItems, shoppingBagItemsQuantity } = (0, _useOrderPreview.useOrderPreview)();
    (0, _logger.logDebug)('OrderProductItem \r\n➡️ isMoreDesktop: ', isMoreDesktop, '\r\n isMoreMobile: ', isMoreMobile, '\r\n itemCount: ', itemCount, '\r\n orderPreviewItems: ', orderPreviewItems);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ...getTestIdProps(_models.TestId.OrderPreview),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_mui.Typography, {
                variant: "body1",
                color: "textSecondary",
                children: [
                    shoppingBagItemsQuantity,
                    " ",
                    formatMessage('items')
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.OnlyDesktop, {
                ...getTestIdProps(_models.TestId.OrderPreviewDesktop),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.OrderItemProductsWrapper, {
                    children: [
                        orderPreviewItems.slice(0, _constants.MAX_DESKTOP_ITEMS - (isMoreDesktop ? 1 : 0)).map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_OrderProductItem.OrderProductItem, {
                                itemCode: item.itemCode,
                                quantity: item.quantity,
                                isHidden: item.isHidden
                            }, item.itemCode)),
                        isMoreDesktop ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OrderProductItem.OrderProductItemPlus, {
                            plusCount: itemCount - _constants.MAX_DESKTOP_ITEMS + 1
                        }) : null
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.OnlyMobile, {
                ...getTestIdProps(_models.TestId.OrderPreviewMobile),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.OrderItemProductsWrapper, {
                    children: [
                        orderPreviewItems.slice(0, _constants.MAX_MOBILE_ITEMS - (isMoreMobile ? 1 : 0)).map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_OrderProductItem.OrderProductItem, {
                                itemCode: item.itemCode,
                                quantity: item.quantity,
                                isHidden: item.isHidden
                            }, item.itemCode)),
                        isMoreMobile ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OrderProductItem.OrderProductItemPlus, {
                            plusCount: itemCount - _constants.MAX_MOBILE_ITEMS + 1
                        }) : null
                    ]
                })
            })
        ]
    });
};
exports.OrderPreview = OrderPreview;
